import { useCallback } from "react"
import { useLocalization } from "./useLocalization"

type ErrorType = "EMPTY" | "REQUIRED" | "INVALID_DATE" | "MIN_AMOUNT_1" | "PRICE_TOO_LOW" | "VALUE_RANGE" | "INVALID_EMAIL"

const FormValidationErrors: Record<ErrorType, number> = {
    EMPTY: 1,
    REQUIRED: 13831,
    INVALID_DATE: 13931,
    INVALID_EMAIL: 290,
    MIN_AMOUNT_1: 1663,
    PRICE_TOO_LOW: 13930,
    VALUE_RANGE: 14043,
}

export function useGetFormValidationError() {
    const { translateText } = useLocalization()
    return useCallback(
        (type: ErrorType, ...values: (string | number)[]) => {
            const text = translateText(FormValidationErrors[type])
            return text.replace(/\{(\d+)\}/g, (_, id) => String(values[id]) ?? "")
        },
        [translateText]
    )
}
